import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../config/globalVariables";

import { setupCache } from "axios-cache-interceptor";
import { axiosRequestMiddleware } from "../middleware/axiosRedirect";

const candidateHistoryClient = axios.create({
  baseURL: `${API_GATEWAY}${PR_DEP}/candidateHistory`,
});
candidateHistoryClient.interceptors.request.use(axiosRequestMiddleware);
const cacheCandidateHistoryClient = setupCache(candidateHistoryClient);
cacheCandidateHistoryClient.interceptors.response.use(
  (response) => {
    if (
      response.status >= 200 &&
      response.status < 300 &&
      response.config.method !== "get"
    ) {
      cacheCandidateHistoryClient.storage.data = {};
    }
    return response;
  },
  async (error) => {
    return Promise.reject(error);
  }
);
export { candidateHistoryClient, cacheCandidateHistoryClient };
